import React from 'react';
import n from '../img/n.jpeg';
import n1 from '../img/n1.jpeg';
import n2 from '../img/n2.jpg';
import n3 from '../img/n3.jpg';
import n4 from '../img/n4.jpg';
import ng1 from '../img/ng1.jpg';
import ng2 from '../img/ng2.jpg';
import ng3 from '../img/ng3.jpg';
import ng4 from '../img/ng4.jpg';
import gg1 from '../img/gg1.jpg';
import gg2 from '../img/gg2.jpg';
import gg3 from '../img/gg3.jpg';
import gg4 from '../img/gg4.jpeg';
import b1 from '../img/b1.jpg';
import b2 from '../img/b2.jpeg';
import AliceCarousel from 'react-alice-carousel';
import 'react-alice-carousel/lib/alice-carousel.css';
import { Link } from 'react-router-dom';
import  {Title,Div, Click, Span, Img} from './StyleComponents';



const Flotante = () => {
	return (
		<>
			<Link className='flecha' to={'/'}>
				&#60;{' '}
			</Link>
			<Click>(Precio válido por fotografía de dos personas)</Click>
			<Title>Flotante negro</Title>

			<AliceCarousel
				disableButtonsControls
				controlsStrategy='alternate responsive'
			>
				<Img src={n1} className='sliderimg' />
				<Img src={n2} className='sliderimg' />
				<Img src={n3} className='sliderimg' />
				<Img src={n4} className='sliderimg' />
				<Img src={n} className='sliderimg' />
			</AliceCarousel>
			<Div>
				
				<Title>
					28 <Span>x</Span> 23 cm{' '}
				</Title>
				<Title>
				<Span>Con ilustración</Span> $40000 <br></br>
				<Span>Con fotografía</Span> $30000 <br></br>
				</Title>
			</Div>

			<Title>Flotante negro Glitter</Title>
			<AliceCarousel disableButtonsControls controlsStrategy='alternate'>
				<Img src={ng1} className='sliderimg' />
				<Img src={ng2} className='sliderimg' />
				<Img src={ng3} className='sliderimg' />
				<Img src={ng4} className='sliderimg' />
			</AliceCarousel>
			<Div>
			
				<Title>
					28 <Span>x</Span> 23 cm{' '}
				</Title>
				<Title>
				<Span>Con ilustración</Span> $40000 <br></br>
				<Span>Con fotografía</Span> $30000 <br></br>
				</Title>
			</Div>

			<Title>Flotante gris Glitter</Title>
			<AliceCarousel disableButtonsControls controlsStrategy='alternate'>
				<Img src={gg2} className='sliderimg' />
				<Img src={gg3} className='sliderimg' />
				<Img src={gg1} className='sliderimg' />
				<Img src={gg4} className='sliderimg' />
			</AliceCarousel>
			<Div>
			
				<Title>
					28 <Span>x</Span> 23 cm{' '}
				</Title>
				<Title>
				<Span>Con ilustración</Span> $40000 <br></br>
				<Span>Con fotografía</Span> $30000 <br></br>
				</Title>
			</Div>
			<Title>Flotante blanco</Title>
			<AliceCarousel disableButtonsControls controlsStrategy='alternate'>
				<Img src={b1} className='sliderimg' />
				<Img src={b2} className='sliderimg' />
			</AliceCarousel>
			<Div>
		
				<Title>
					28 <Span>x</Span> 23 cm{' '}
				</Title>
				<Title>
				<Span>Con ilustración</Span> $40000 <br></br>
				<Span>Con fotografía</Span> $30000 <br></br>
				</Title>
			</Div>
		</>
	);
};

export default Flotante;
